import React, { useState, useEffect, useRef } from 'react'
// import * as Sentry from "@sentry/browser";
// import 'tinymce/tinymce'
// import 'tinymce/icons/default'
// import 'tinymce/themes/silver'
// import 'tinymce/plugins/advlist'
// import 'tinymce/plugins/autolink'
// import 'tinymce/plugins/lists'
// import 'tinymce/plugins/link'
// import 'tinymce/plugins/image'
// import 'tinymce/plugins/charmap'
// import 'tinymce/plugins/print'
// import 'tinymce/plugins/preview'
// import 'tinymce/plugins/anchor'
// import 'tinymce/plugins/searchreplace'
// import 'tinymce/plugins/visualblocks'
// import 'tinymce/plugins/code'
// import 'tinymce/plugins/fullscreen'
// import 'tinymce/plugins/insertdatetime'
// import 'tinymce/plugins/media'
// import 'tinymce/plugins/table'
// import 'tinymce/plugins/paste'

// import 'tinymce/plugins/help'
// import 'tinymce/plugins/wordcount'

// import 'tinymce/plugins/noneditable'
// import 'tinymce/plugins/paste'
// import 'tinymce/plugins/link'
// import 'tinymce/plugins/image'
// import 'tinymce/plugins/table'
// import 'tinymce/skins/ui/oxide/skin.min.css'
// import 'tinymce/skins/ui/oxide/content.min.css'
// import 'tinymce/skins/content/default/content.min.css'
import { Editor } from '@tinymce/tinymce-react'
import { injectIntl } from 'react-intl'
import {
  ButtonDropdown,
  DropdownItem,
  DropdownToggle,
  DropdownMenu,
  Row,
  Card,
  CardBody,
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
  FormGroup,
  Label,
  Input
} from 'reactstrap'
import { AvForm } from 'availity-reactstrap-validation'
// import LanguageDetect from 'languagedetect'
// import { franc } from 'franc'
import isEmpty from 'lodash.isempty'
import { useLocation, useHistory } from "react-router-dom"
// import remove from 'lodash.remove'
import { Colxx } from '../../../components/common/CustomBootstrap'
import IntlMessages from '../../../helpers/IntlMessages'
import 'react-tagsinput/react-tagsinput.css'
// import 'react-quill/dist/quill.snow.css'
// import 'react-quill/dist/quill.bubble.css'
import StateButton from '../../../components/common/StateButton'
import { NotificationManager } from '../../../components/common/react-notifications'
import RephraseTools from './RephraseTools'
import {
  removeInvalidTags, getPhrasesToParaphrase, splitTextByTokens, getDomainOrigin, paraphraseSentence
} from './utilsCreate'

const axios = require('axios')

const Promise = require('bluebird')
const cheerio = require('cheerio')


const {
  addHighlightedParaphrase, diffTextOnChangeText, copyTextToClipboard, rephraseSentence, undoPhrase,
  copyParaphraseToClipboard, addSynonymsList, removeSynonymsList, removeRephraseTools, fixEntityEncoding
} = require('./utils')

let initialValueOriginal = ''
const initialValueParaphrased = ''

// esse objeto é necessário para passar os synonyms para dentro do tiny
// se fosse um estado do react não funcionaria
let synonyms2 = {}
let trial2 = {}
let usuarioPagante2 = {}

let totalParagraphsToRewrite = 0
let totalParagraphsRewrited = 0

function EditorsSummaryChatGPT(props) {
  const { messages } = props.intl
  const history = useHistory()

  const location = useLocation()
  const summarizedText = location?.state?.text

  const {
    tool = 'summarize'
  } = props

  const [modalBack, setModalBack] = useState(false)
  const toggleModalBack = () => { setModalBack(!modalBack) }
  const [modalBackIP, setModalBackIP] = useState(false)
  const toggleModalBackIPVazio = () => { setModalBackIP(!modalBackIP) }

  const [dropdownBasicOpen, setDropdownBasicOpen] = useState(false);


  const [spanCursor] = useState('<span id="cursor" class="added"></span>')

  const [paraphrases, setParaphrases] = useState([])
  const [synonymsRephrase, setSynonymsRephrase] = useState({})

  const editorOriginal = useRef(null)
  const editorParaphrased = useRef(null)

  const [showButtonParaphrase, setShowButtonParaphrase] = useState(false)

  const [classEditorOriginal, setClassEditorOriginal] = useState('')
  const [classEditorParaphrase, setClassEditorParaphrase] = useState('d-none d-md-block')

  const [synonyms, setSynonyms] = useState({})
  const [trial, setTrial] = useState(false)
  const [ip, setIP] = useState('')
  let ip2 = 0
  const [email, setEmail] = useState('')
  let email2 = ''
  const [userID, setUserID] = useState('')
  let userID2 = 0
  const [usuarioPagante, setUsuarioPagante] = useState(false)

  const [planoAtivoCliente, setPlanoAtivoCliente] = useState({})
  // const [geolocation, setGeolocation] = useState('');

  const [socketIsPaused, setSocketPause] = useState(false);

  const [tipoResumo, setTipoResumo] = useState('resumo-comum') // padrão é resumo-comum
  const [modoResumo, setModoResumo] = useState('modo-padrao') // padrão é resumo-comum
  const [isSummarizing, setIsSummarizing] = useState(false)

  
  // const [totalParagraphsToRewrite, setTotalParagraphsToRewrite] = useState(0)
  // const [totalParagraphsRewrited, setTotalParagraphsRewrited] = useState(0)

  const formRef = useRef(null)

  const [ws, setWs] = useState(null);
  // const clientRef = useRef(null);


  const clientRef = useRef(null);
  const [waitingToReconnect, setWaitingToReconnect] = useState(null);
  const [messagesSocket, setMessagesSocket] = useState([]);
  const [isOpen, setIsOpen] = useState(false);

  function addMessage(message) {
    setMessagesSocket([...messagesSocket, message]); 
  }

  useEffect(() => {

    if (waitingToReconnect) {
      return;
    }

    // Only set up the websocket once
    if (!clientRef.current) {
      const client = new WebSocket('wss://e2how8spek.execute-api.us-east-1.amazonaws.com/dev');
      clientRef.current = client;

      window.client = client;

      client.onerror = (e) => console.error(e);

      client.onopen = () => {
        setIsOpen(true);
        console.log('ws opened');

        // Se tinha sido enviado o texto para resumir, mas a conexão caiu
        // manda resumir novamente, para funcionar corretamente
        if (isSummarizing) onTextSubmit()
      };

      client.onclose = () => {

        if (clientRef.current) {
          // Connection failed
          console.log('ws closed by server');
        } else {
          // Cleanup initiated from app side, can return here, to not attempt a reconnect
          // console.log('ws closed by app component unmount');
          return;
        }

        if (waitingToReconnect) {
          return;
        };

        // Parse event code and log
        setIsOpen(false);
        // console.log('ws closed');

        // Setting this will trigger a re-run of the effect,
        // cleaning up the current websocket, but not setting
        // up a new one right away
        setWaitingToReconnect(true);

        // This will trigger another re-run, and because it is false,
        // the socket will be set up again
        setTimeout(() => setWaitingToReconnect(null), 5000);
      };

      client.onmessage = event => {
        // console.log('received message', event);
        addMessage(`received '${event.data}'`);

        if (event.data
          && (JSON.parse(event.data).message === "Internal server error"
          || JSON.parse(event.data).message === "Endpoint request timed out")) {
            // console.log('CAIU AQUI')
            // setWaitingToReconnect(null)
          return
        }

        onGetRewritedText(event.data, userID2, email2, ip2)
        return ''
      };


      return () => {

        clientRef.current = null;

        client.close();
      }
    }

  }, [waitingToReconnect]);

  useEffect(() => { trial2 = trial }, [trial])
  useEffect(() => { usuarioPagante2 = usuarioPagante }, [usuarioPagante])

  useEffect(() => {
    if (formRef.current) {
      setShowButtonParaphrase(true)
    }
  }, [formRef])

  useEffect(() => {
    synonyms2 = Object.assign({}, synonyms2, synonymsRephrase)
  }, [synonymsRephrase])

  useEffect(() => {
    synonyms2 = synonyms
  }, [synonyms])

  useEffect(() => {
    if (!isEmpty(summarizedText)) initialValueOriginal = summarizedText
  }, [summarizedText])

  useEffect(() => {
    const email = window.location.pathname.split('app/summary2/')[1]
    console.log('email:', email)
    setEmail(email || '')
    email2 = email

    async function fetchData() {
      // SE EM ALGUM MOMENTO PARAR DE FUNCIONAR, VER A LISTA NESSE SITE
      // https://stackoverflow.com/questions/391979/how-to-get-clients-ip-address-using-javascript

      const intervalId = setInterval(async () => {
        try {
          await axios.get('https://ipapi.co/json/', { timeout: 3000 })
          .then((response) => {
            console.log('https://ipapi.co/json/', response.data.ip)
            if ((isEmpty(ip) || ip === "Not found")) {
              setIP(response.data.ip)
              ip2 = response.data.ip
              clearInterval(intervalId);
            }
          })
        } catch (error) {
          console.log("error: ", error);
        }

        try {
          await axios.get('https://api.ipregistry.co/?key=tryout', { timeout: 3000 })
          .then((response) => {
            console.log('https://api.ipregistry.co/?key=tryout', response.data.ip)
            if ((isEmpty(ip) || ip === "Not found")) {
              setIP(response.data.ip)
              ip2 = response.data.ip
              clearInterval(intervalId);
            }
          })
        } catch (error) {
          console.log("error: ", error);
        }

        try {
          await axios.get('https://geolocation-db.com/json/', { timeout: 3000 })
          .then((response) => {
            console.log('https://geolocation-db.com/json/', response.data.IPv4 || response.data.IPv6)
            if ((isEmpty(ip) || ip === "Not found")) {
              setIP(response.data.IPv4 || response.data.IPv6)
              ip2 = response.data.IPv4 || response.data.IPv6
              clearInterval(intervalId);
            }
          })
        } catch (error) {
          console.log("error: ", error);
        }

        try {
          await axios.get('https://icanhazip.com/', { timeout: 3000 })
          .then((response) => {
            console.log('https://icanhazip.com/', response.data)
            if ((isEmpty(ip) || ip === "Not found")) {
              if ((isEmpty(response.data) || response.data === "Not found")) {
                setIP(response.data)
                ip2 = response.data
              }
              clearInterval(intervalId);
            }
          })
        } catch (error) {
          console.log("error: ", error);
        }

        console.log("IP", ip)
        console.log("IP2", ip2)

      }, 1000);

      if (isEmpty(email) || email === undefined || email === 'undefined') {
        setTrial(true)
        return
      }

    await axios.get(`https://reescrever.app/wp-json/api/v1/dados/subscription2/${email}`)
        .then((response) => {
          response.data.forEach((pag) => {
            const {
              plano, data, status, userID, code
            } = pag

            setUserID(userID)
            userID2 = userID

            const date = new Date(parseInt(data) * 1000)
            const date2 = new Date()

            const diffMinute = Math.ceil(Math.abs(date2 - date) / 60000)

            if ((plano === 'Grátis' || isEmpty(plano)) && usuarioPagante2 === false) setTrial(true)
            else if (['Semana Resumir',
              'Mensal Resumir',
              'Trimestral Resumir',
              'Semestral Resumir',
              'Anual Resumir',
              'Semana Resumir + Reescrever',
              'Mensal Resumir + Reescrever',
              'Trimestral Resumir + Reescrever',
              'Semestral Resumir + Reescrever',
              'Anual Resumir + Reescrever'
            ].includes(plano) && status !== 'refunded') {

              if (
                ((plano === 'Semana Resumir' || plano === 'Semana Resumir + Reescrever')
                  && diffMinute < 10080)
                  || ((plano === 'Mensal Resumir' || plano === 'Mensal Resumir + Reescrever')
                  && diffMinute < 44640)
                  || ((plano === 'Trimestral Resumir' || plano === 'Trimestral Resumir + Reescrever')
                  && diffMinute < 133920)
                  || ((plano === 'Semestral Resumir' || plano === 'Semestral Resumir + Reescrever')
                  && diffMinute < 267840)
                  || ((plano === 'Anual Resumir' || plano === 'Anual Resumir + Reescrever')
                  && diffMinute < 527040)
              ) {
                setUsuarioPagante(true)
              }

            } else if (['Semana Reescrever',
              'Mensal Reescrever',
              'Trimestral Reescrever',
              'Semestral Reescrever',
              'Anual Reescrever'
            ].includes(plano) && status !== 'refunded') {

              if (
                (plano === 'Semana Reescrever' && diffMinute < 10080)
                || (plano === 'Mensal Reescrever' && diffMinute < 44640)
                || (plano === 'Trimestral Reescrever' && diffMinute < 133920)
                || (plano === 'Semestral Reescrever' && diffMinute < 267840)
                || (plano === 'Anual Reescrever' && diffMinute < 527040)
              ) {
                setPlanoAtivoCliente(pag)
              }
            }
          })
        })
        .catch(() => { setTrial(true) })
    }

    fetchData()
  }, [])

  const delay = ms => new Promise(res => setTimeout(res, ms));

  const onSubmitText = async (text, html) => {
    console.log('onSubmitText:', text)
    NotificationManager.remove(NotificationManager.listNotify[0])
    NotificationManager.info('Seu resumo está sendo gerado', '', 0)
    
      if (trial) {
        var maxLength = 300;
        var words = text.split(/\s+/);
        var slicedWords = words.slice(0, maxLength);
        text = slicedWords.join(' ');
      }
      if (trial === false) {
        var maxLength = 5000;
        var words = text.split(/\s+/);
        var slicedWords = words.slice(0, maxLength);
        text = slicedWords.join(' ');
      }
    
    // const html = removeInvalidTags(text)
    // const paragraphs = getPhrasesToParaphrase(html, trial)
    // totalParagraphsToRewrite = paragraphs.length

    editorParaphrased.current.dom.addClass(editorParaphrased.current.dom.select('body'), 'rewriting');
    editorParaphrased.current.setContent(html)

    if (usuarioPagante2 === true) {
      // NÃO VERIFICA IP, POIS O USUÁRIO JÁ É PAGANTE
    } else if ((isEmpty(ip) || ip === "Not found")) {
      console.log('ERRO DESCONHECIDO')

      let counter = 0
      const intervalId = setInterval(async () => {
        counter++;
        console.log(counter, 'segundo')

        await axios.get('https://geolocation-db.com/json/', { timeout: 3000 })
          .then((response) => {
            console.log('https://geolocation-db.com/json/', response.data.IPv4 || response.data.IPv6)
            if ((isEmpty(ip) || ip === "Not found")) {
              setIP(response.data.IPv4 || response.data.IPv6)
              ip2 = response.data.IPv4 || response.data.IPv6
              clearInterval(intervalId);
            }
          })

        await axios.get('https://icanhazip.com/', { timeout: 3000 })
          .then((response) => {
            console.log('https://icanhazip.com/', response.data)
            if ((isEmpty(ip) || ip === "Not found")) {
              if ((isEmpty(response.data) || response.data === "Not found")) {
                setIP(response.data)
                ip2 = response.data
              }
              clearInterval(intervalId);
            }
          })

        // ESPERA 5 SEGUNDOS ANTES DE NÃO EXECUTAR MAIS
        if (counter >= 5) {
          clearInterval(intervalId)
          if ((isEmpty(ip) || ip === "Not found")) window.parent.location.href = "https://reescrever.app/erro-desconhecido/";
        }
      }, 1000);

      await delay(5000);
    } else if (usuarioPagante2 === false && trial === false) {
      // Se cair aqui, então é porque o usuário pagou apenas o reescrever, não o resumir
      // console.log('planoAtivoCliente', JSON.stringify(planoAtivoCliente, null, 2))
      const {
        plano, gateway, code
      } = planoAtivoCliente

      const upgradePlans = ["Mensal Reescrever", "Trimestral Reescrever", "Semestral Reescrever", "Anual Reescrever"];

      if (plano === "Semana Reescrever" || gateway === 'check') {
        // Pode comprar o plano semana ou assinar plano mensal / trimestral
        window.parent.location.href = `https://reescrever.app/precos-resumir`;
      } else if (upgradePlans.includes(plano)) {
        // mostra valor pro-rata para o cliente pagar diferença e altera para plano do tipo resumir + reescrever
        window.parent.location.href = `https://reescrever.app/upgrade/?code=${code}`;
      } else {
        // Não possui nenhum plano ativo
        window.parent.location.href = `https://reescrever.app/precos/#resumir`;
      }
    }

    // VERIFICA SE O USUÁRIO JÁ FEZ 1 TEXTO GRÁTIS NO DIA
    console.log('trial1:', trial)
    if (trial) {
      console.log('trial2:', trial)
      let usoGratisDisponivel = true
      // console.log('ip:', ip)
      await axios.post(`https://q1f8kd88uc.execute-api.us-east-1.amazonaws.com/prod/daily-use`, { ip })
        .then((response) => {
          // console.log('response.data:', response.data)
          // if (response && response.data && response.data !== "" && response.data >= 1) {
          if (response && response.data && response.data === "disallow") {
            usoGratisDisponivel = false
            window.parent.location.href = "https://reescrever.app/limite-de-uso-resumir/";
          }
        })

      if (usoGratisDisponivel === false) return
    }
    
    if (clientRef.current) {
      console.log("tipoResumo: ", tipoResumo);
      console.log("modoResumo: ", modoResumo);
      setIsSummarizing(true)
      clientRef.current.send(JSON.stringify({ text, tipoResumo, modoResumo }))
      // paragraphs.forEach(paragraph => {
      //   clientRef.current.send(JSON.stringify({ text: paragraph, tipoResumo }));
      // })
    }

  }

  const onGetRewritedText = async (data, userID, email, ip) => {

    setClassEditorOriginal('d-none d-md-block')
    setClassEditorParaphrase('')

    data = JSON.parse(data)
    console.log("data: ", data);


    const index = Math.floor(Math.random() * (9999999999 - 1111111111 + 1) + 1111111111)

    let paraphrasedText = editorParaphrased.current.getContent(editorParaphrased.current.getBody())
    console.log("paraphrasedText: ", paraphrasedText);
    let originalText = editorOriginal.current.getContent(editorOriginal.current.getBody())
    console.log("originalText: ", originalText);

    if (data.textSummarized) paraphrasedText = `<span id="paraphrase-${index}" class="paraphrase">${data.textSummarized}</span>`
    console.log("data.originalText: ", data.originalText);
    if (originalText.includes(data.originalText)) originalText = originalText.replace(data.originalText, `<span class="original paraphrase-${index}">${data.originalText}</span>`)

    editorParaphrased.current.setContent(paraphrasedText)
    editorOriginal.current.setContent(originalText)

    // diffTextOnChangeText({ editorOriginal, editorParaphrased, paraphraseID: `paraphrase-${index}` })
    

    totalParagraphsRewrited = totalParagraphsRewrited + 1

    

    // editorOriginal.current.setContent(data.leftSentenceWithDiff)

    // if (totalParagraphsRewrited === totalParagraphsToRewrite) {

      // REMOVER TODAS OCORRÊNCIA DO SPAN CURSOR NO TEXTO
      editorParaphrased.current.setContent(editorParaphrased.current.getBody().innerHTML.replace(/<span id="cursor" class="added"><\/span>/g, ''));

      editorParaphrased.current.dom.removeClass(editorParaphrased.current.dom.select('body'), 'rewriting')
      NotificationManager.remove(NotificationManager.listNotify[0])
      setShowButtonParaphrase(false)
      editorParaphrased.current.setMode('design')
      // editorOriginal.current.setMode('readonly')
  
      editorOriginal.current.iframeElement.contentWindow.scrollTo(0, 0)
      editorParaphrased.current.iframeElement.contentWindow.scrollTo(0, 0)

      totalParagraphsRewrited = 0

      // diffTextOnChangeText({ editorOriginal, editorParaphrased })
    // }

    const countWords = editorOriginal.current.plugins.wordcount.getCount()

    // console.log('ip1:', ip)
    // TABELA USO-GRATIS-REESCREVER
    // console.log('ipppppp:', ip)
    await axios.post(`https://q1f8kd88uc.execute-api.us-east-1.amazonaws.com/prod/daily-use`, {
      ip, increment: true, email, tool: "resumir", countWords
    })

    // TABELA USO-FERRAMENTAS
    if (!trial) {
      try {
        await axios.post(`https://q1f8kd88uc.execute-api.us-east-1.amazonaws.com/prod/usage`, {
          userID, email, ferramenta: "resumir", countWords
        })
      } catch (error) {
        console.log('error:', error)
      }
    }
  }

  const onTextSubmit = () => {

    // NÃO CONSEGUIU CAPTURAR O IP DO CLIENTE, E É UM CLIENTE GRÁTIS
    // ENTÃO NÃO PERMITE USAR A FERRAMENTA, SENÃO USARIA GRÁTIS SEM LIMITES
    if (!(ip) && usuarioPagante === false) return

    if (isEmpty(editorOriginal.current.getContent())) {
      NotificationManager.error('Insira um texto antes de clicar no botão')
      return
    }

    // Quando o usuário digita espaços diretamente no TinyMCE, ele troca por &nbsp; porém isso é ruim
    // para o diff, pois em alguns casos pode falar que foi alterado algo quando não foi
    // Portanto, essa linha abaixo REMOVE &nbsp; do texto original que foi digitado
    // Todos &nbsp; que tinham ao colar o texto foram removidos anteriormente, no PastePostProcess
    editorOriginal.current.setContent(editorOriginal.current.getContent().replace(/\u00a0/g, " "))

    onSubmitText(editorOriginal.current.getContent({ format: "text" }), editorOriginal.current.getContent({ format: "html" }))
  }

  const newParaphrase = () => {
    editorParaphrased.current.setContent('')
    editorOriginal.current.setContent('')
    editorParaphrased.current.setMode('readonly')
    editorOriginal.current.setMode('design')
    setShowButtonParaphrase(true)
    editorOriginal.current.focus()

    setClassEditorOriginal('')
    setClassEditorParaphrase('d-none d-md-block')
  }

  const buttonText = {
    synonymous: 'Generate text',
    spintax: 'Generate spintax',
    paraphrase: 'Generate paraphrase',
    summarize: 'Generate summary'
  }

  return (
    <Card className="h-100">
      <CardBody>
        <RephraseTools
          editorOriginal={editorOriginal}
          editorParaphrased={editorParaphrased}
          paraphrases={paraphrases}
          setParaphrases={setParaphrases}
          setSynonymsRephrase={setSynonymsRephrase}
        />
        <AvForm
              className="av-tooltip tooltip-label-bottom w-100"
              onSubmit={onTextSubmit}
              ref={formRef}
            >
        <Row>
          <Colxx md="6" xl="6" xxl="6" lg="6" className={`mb-4 ${classEditorOriginal}`}>
            <FormGroup>
              <Label for="exampleSelect">
                Tipo do Resumo
              </Label>
              <Input
                id="tipoResumo"
                name="tipoResumo"
                type="select"
                onChange={(event) => { setTipoResumo(event.target.value) }}
              >
                <option value="resumo-comum">
                  Resumo Comum
                </option>
                <option value="resumo-topicos">
                  Resumo em Tópicos
                </option>
                <option value="resumo-critico">
                  Resumo Crítico
                </option>
              </Input>
            </FormGroup>
          </Colxx>

          <Colxx md="6" xl="6" xxl="6" lg="6" className={`mb-4 ${classEditorOriginal}`}>
            <FormGroup>
              <Label for="exampleSelect">
                Modo de Escrita
              </Label>
              <Input
                id="tipoModo"
                name="tipoModo"
                type="select"
                onChange={(event) => { setModoResumo(event.target.value) }}
              >
                <option value="modo-padrao">
                  Padrão
                </option>
                <option value="modo-formal">
                  Formal
                </option>
                <option value="modo-informal">
                  Informal
                </option>
                <option value="modo-academico">
                  Acadêmico
                </option>
                <option value="modo-crianca">
                  Escrever como criança
                </option>
              </Input>
            </FormGroup>
          </Colxx>
        </Row>

        <Row>
          <Colxx md="6" xl="6" xxl="6" lg="6" className={`mb-4 ${classEditorOriginal}`}>
            
              <Editor
                ref={editorOriginal}
                initialValue={initialValueOriginal}
                init={{
                  language: "pt_BR",
                  branding: false,
                  body_id: 'editorOriginal',
                  placeholder: `Cole seu texto aqui. Depois clique no botão Resumir. Para finalizar, revise o texto para garantir total legibilidade e autênticidade.`,
                  entity_encoding: 'raw',
                  entities: 'nbsp,160',
                  auto_focus: true,
                  height: 430,
                  width: '100%',
                  menubar: false,
                  plugins: [
                    'advlist autolink lists link image charmap print preview anchor',
                    'searchreplace visualblocks code fullscreen',
                    'insertdatetime media table paste code help wordcount code noneditable nonbreaking'
                  ],
                  toolbar: 'formatselect | alignleft aligncenter alignright alignjustify | bullist numlist',
                  fullscreen_native: true,
                  browser_spellcheck: true,
                  contextmenu: false,
                  elementpath: false,
                  invalid_elements: "div",
                  forced_root_block: 'p',
                  nonbreaking_wrap: false,
                  content_css: '/assets/css/paraphrase2.css',
                  setup: (editor) => {
                    editor.on('init', () => {
                      editorOriginal.current = editor
                      // editorOriginal.current.getWin().onscroll = () => {
                      //   // bloqueia o scroll (deixa o scroll igual do editorParaphrased sempre que tentar mexer, dando a impressão que está bloqueado)
                      //   if (!isEmpty(editorParaphrased.current.getContent())) editorOriginal.current.iframeElement.contentWindow.scrollTo(0, editorParaphrased.current.dom.getViewPort(editorParaphrased.current.getWin()).y)
                      // }
                    })

                    let showLimit = true
                    let showLimit5000 = true
                    const countWords = (e) => {
                      if (trial2) {
                        const allText = e.content + window.tinymce.activeEditor.getContent({ format: "text" })
                        if (allText.split(" ").length > 300 && showLimit) {
                          NotificationManager.error(messages['The limit is 300 words for the free plan'], '', 0)
                          showLimit = false
                        } else if (allText.split(" ").length < 300) {
                          NotificationManager.remove(NotificationManager.listNotify[0])
                          showLimit = true
                        }
                      } else {
                        if (trial2 === false) {
                          const allText = e.content + window.tinymce.activeEditor.getContent({ format: "text" })
                          if (allText.split(" ").length > 5000 && showLimit5000) {
                            NotificationManager.error(messages['The limit is 5000 words for paid plans'], '', 0)
                            showLimit5000 = false
                          } else if (allText.split(" ").length < 5000) {
                            NotificationManager.remove(NotificationManager.listNotify[0])
                            showLimit5000 = true
                          }
                        } else {
                          NotificationManager.remove(NotificationManager.listNotify[0])
                          showLimit = true
                          showLimit5000 = true
                        }
                      }
                    }

                    editor.on('PastePreProcess', (e) => {
                      // console.log('e.content:', e.content)
                      e.content = e.content
                        .replace(/<\/?a[^>]*>/g, '')
                        .replace(/<div>/g, '<p>')
                        .replace(/<\/div>/g, '</p>')
                        .replace(/<\/?span[^>]*>/g, '')
                        .replace(/​/g, ' ') // Remove espaço U+200B
                        .replace(/([^.][^.!?:”"')\]])<[Bb][Rr][^>]*>([^A-Z]|[A-Z])/gm, "$1 $2")
                      // console.log('e.content:', e.content)
                    });

                    editor.on('PastePostProcess', (e) => {
                      // REMOVE TODOS &nbps; ao colar o texto
                      e.node.innerHTML = e.node.innerHTML.replace(/&nbsp;/ig, " ")
                        .replace(/<strong>|<\/strong>/g, '')
                        .replace(/<b>|<\/b>/g, '')
                        .replace(/<em>|<\/em>/g, '')
                        .replace(/<u>|<\/u>/g, '')
                        .replace(/<i>|<\/i>/g, '')
                        .replace(/<sup>|<\/sup>/g, '')
                        // regex abaixo remove as tags com atributos <tag eatributosaqui>
                        .replace(/<\/?span[^>]*>/g, '')
                        .replace(/<\/?strong[^>]*>/g, ' ')
                        .replace(/<\/?b[^>]*>/g, ' ')
                        .replace(/<\/?em[^>]*>/g, ' ')
                        .replace(/<\/?u[^>]*>/g, ' ')
                        .replace(/<\/?i[^>]*>/g, ' ')
                        .replace(/<\/?sup[^>]*>/g, ' ')
                    });

                    editor.on('Paste Change input Undo Redo Keydown Keyup', (e) => {
                      countWords(e)
                    })
                  }
                }}
              />

              <Row>
                <Colxx xl="12" lg="12" className="mb-4 pt-4">
                  <div className="position-absolute l-0 ml-3">
                    {!showButtonParaphrase && (
                      isEmpty(summarizedText)
                        ? (
                          <StateButton
                            block
                            color="primary"
                            className="text-uppercase mt-4"
                            onClick={toggleModalBack}
                          >
                            <IntlMessages id="NEW TEXT" />
                          </StateButton>
                        )
                        : (
                          <StateButton
                            block
                            color="primary"
                            className="text-uppercase mt-4"
                            onClick={() => { history.push(`/app/summary2/${email}`) }}
                          >
                            NOVO RESUMO
                          </StateButton>
                        )
                    )}
                  </div>

                  <div className="position-absolute r-0 mr-3">
                    {showButtonParaphrase && (
                      <StateButton
                        block
                        formRef={formRef.current}
                        color="primary"
                        className="text-uppercase mt-4"
                        // disabled={!(ip) && usuarioPagante === false}
                        onClick={() => {
                          if (!(ip) && usuarioPagante === false) {
                            toggleModalBackIPVazio()
                          }
                        }}
                      >
                        RESUMIR
                      </StateButton>
                    )}
                  </div>
                </Colxx>
              </Row>

            
          </Colxx>
          <Colxx md="6" xl="6" xxl="6" lg="6" className={`mb-4 ${classEditorParaphrase}`}>
            <Editor
              ref={editorParaphrased}
              initialValue={initialValueParaphrased}
              init={{
                language: "pt_BR",
                branding: false,
                body_id: 'editorParaphrased',
                entity_encoding: 'raw',
                entities: 'nbsp,160',
                height: 430,
                width: '100%',
                menubar: false,
                plugins: [
                  'advlist autolink lists link image charmap print preview anchor',
                  'searchreplace visualblocks code fullscreen',
                  'insertdatetime media table paste code help wordcount code noneditable nonbreaking'
                ],
                toolbar: 'formatselect | alignleft aligncenter alignright alignjustify | bullist numlist',
                fullscreen_native: true,
                browser_spellcheck: true,
                contextmenu: false,
                elementpath: false,
                invalid_elements: "div",
                forced_root_block: 'p',
                nonbreaking_wrap: false,
                content_css: '/assets/css/paraphrase2.css',
                setup: (editor) => {

                  editor.on('init', () => {
                    editor.setMode('readonly')

                    editorParaphrased.current = editor
                    editorParaphrased.current.getWin().onscroll = () => {
                      const editorOriginalScrollHeight = editorOriginal.current.iframeElement.contentWindow.document.scrollingElement.scrollHeight
                      const editorOriginalClientHeight = editorOriginal.current.iframeElement.contentWindow.document.scrollingElement.clientHeight
                      const editorOriginalTop = editorOriginalScrollHeight - editorOriginalClientHeight

                      const editorParaphrasedScrollHeight = editorParaphrased.current.iframeElement.contentWindow.document.scrollingElement.scrollHeight
                      const editorParaphrasedClientHeight = editorParaphrased.current.iframeElement.contentWindow.document.scrollingElement.clientHeight
                      const editorParaphrasedTop = editorParaphrasedScrollHeight - editorParaphrasedClientHeight

                      const editorParaphrasedYoffsetHeight = editorParaphrased.current.iframeElement.contentWindow.document.scrollingElement.offsetHeight
                      const editorOriginalYoffsetHeight = editorOriginal.current.iframeElement.contentWindow.document.scrollingElement.offsetHeight

                      const editorParaphrasedYHeightScroll = editorParaphrased.current.dom.getViewPort(editorParaphrased.current.getWin()).y
                      let scroll = 0
                      if (editorOriginalYoffsetHeight > editorParaphrasedYoffsetHeight) {
                        // console.log('aqui1', editorOriginalYoffsetHeight, editorParaphrasedYoffsetHeight, editorParaphrased.current.dom.getViewPort(editorParaphrased.current.getWin()).y)
                        scroll = (editorOriginalTop / editorParaphrasedTop) * editorParaphrasedYHeightScroll
                      } else {
                        // TODO: testar pra ver se isso realmente funciona caso o editor original for menor que o editor parafraseado
                        scroll = (editorParaphrasedTop / editorOriginalTop) * editorParaphrasedYHeightScroll
                      }

                      editorOriginal.current.iframeElement.contentWindow.scrollTo(0, scroll)
                    }
                  })

                }
              }}
            />

            <Colxx md="12" xl="12" xxl="12" lg="12" className={`mb-4 d-flex`}>
            {/* Mostra abaixo 800px, ESCONDE O ORIGINAL */}
            <Row className="mb-4 mt-4 d-block d-md-none">
              <Colxx xl="6" xxl="6" lg="6">
                <div className="position-absolute l-0 ml-3">
                  {!showButtonParaphrase && (
                    isEmpty(summarizedText)
                      ? (
                        <StateButton
                          block
                          color="primary"
                          className="text-uppercase mt-4"
                          onClick={toggleModalBack}
                        >
                          <IntlMessages id="NEW TEXT" />
                        </StateButton>
                      )
                      : (
                        <StateButton
                          block
                          color="primary"
                          className="text-uppercase mt-4"
                          onClick={() => { history.push(`/app/summary2/${email}`) }}
                        >
                          NOVO RESUMO
                        </StateButton>
                      )
                  )}
                </div>
              </Colxx>
            </Row>

            {/* Mostra acima 800px, MOSTRA O ORIGINAL */}
            <Row className="mb-4 mt-4">
              {!showButtonParaphrase && (
                <>
                  <ButtonDropdown
                    direction="up"
                    isOpen={dropdownBasicOpen}
                    toggle={() => setDropdownBasicOpen(!dropdownBasicOpen)}
                    className="position-absolute mb-5 r-0 mr-3"
                  >
                    <DropdownToggle caret color="primary">
                      AÇÕES
                    </DropdownToggle>
                    <DropdownMenu right>
                      <DropdownItem
                        onClick={toggleModalBack}
                      >
                        NOVO RESUMO
                      </DropdownItem>
                      <DropdownItem
                        onClick={() => {
                          console.log('TEXTO1', editorParaphrased.current.getContent())
                          console.log('TEXTO2', editorParaphrased.current.getContent({ format: "text" }))
                          console.log('TEXTO3', editorParaphrased.current.getContent({ format: "html" }))
                          let cleanedHtml = editorParaphrased.current.getContent({ format: "html" }).replace(/<span[^>]*>(.*?)<\/span>/g, "$1");
                          cleanedHtml = cleanedHtml.replace(/<span[^>]*>(.*?)<\/span>/g, "$1");
                          console.log('TEXTO4', cleanedHtml)

                          
                          history.push(`/app/paraphrase2/${email}`, { text: cleanedHtml });
                        }}
                      >
                        REESCREVER RESUMO
                      </DropdownItem>
                      <DropdownItem
                        onClick={() => { copyTextToClipboard(editorParaphrased) }}
                      >
                        COPIAR RESUMO
                      </DropdownItem>
                    </DropdownMenu>
                  </ButtonDropdown>
                </>
              )}
            </Row>

            </Colxx>

          </Colxx>
        </Row>

        </AvForm>

        <Modal
          isOpen={modalBack}
          toggle={toggleModalBack}
        >
          <ModalHeader toggle={toggleModalBack}>
            <IntlMessages id="Are you sure?" />
          </ModalHeader>
          <ModalBody>
            <p>
              <IntlMessages id="Make sure you have saved text before proceeding. It will not be possible to recover it." />
            </p>
          </ModalBody>
          <ModalFooter>
            <StateButton
              onClick={() => {
                newParaphrase()
                toggleModalBack()
              }}
              color="primary"
            >
              <IntlMessages id="Yes" />
            </StateButton>
            {' '}
            <StateButton color="outline-primary" onClick={toggleModalBack}>
              <IntlMessages id="No" />
            </StateButton>
          </ModalFooter>
        </Modal>

        {/* MODAL IP NÃO CAPTURADO */}
        <Modal
          isOpen={modalBackIP}
          toggle={toggleModalBackIPVazio}
        >
          <ModalHeader toggle={toggleModalBackIPVazio}>
            {/* <IntlMessages id="Are you sure?" /> */}
            Uma parte essencial do sistema não está sendo carregada adequadamente
          </ModalHeader>
          <ModalBody>
            <p>
              {/* <IntlMessages id="Make sure you have saved text before proceeding. It will not be possible to recover it." /> */}
              Se você possui uma conta paga e está visualizando esta mensagem, é provável que você não esteja autenticado em sua conta. Portanto, ao fazer o login, essa mensagem será removida e você conseguirá resumir corretamente.
              {' '}
              <strong><a href="https://reescrever.app/login/">Clique aqui para efetuar o login</a></strong>
              .
            </p>
            <p>
              Se você estiver acessando por um dispositivo móvel e já estiver devidamente autenticado, mas ainda assim visualizar essa mensagem, é provável que esteja usando um navegador integrado que não armazena o cache do login. Para solucionar esse problema, acesse nosso site pelo navegador Google Chrome ou Mozilla Firefox, pois esses navegadores armazenam o cache do login e permitirão que você utilize normalmente.
            </p>
            <p>Caso necessite de auxílio ou possua alguma dúvida, estamos disponíveis para ajudar.</p>
            {/* <p>Caso você seja um usuário gratuito, veja possíveis causas e soluções:</p>
            <p>
              <ul>
                <li>Seu navegador está bloqueando: experimente utilizar outro navegador.</li>
                <li>Seu antivírus está bloqueando: desabilite temporariamente para testar. Se o sistema funcionar corretamente, é possível que o antivírus esteja causando o bloqueio. Nesse caso, procure orientações específicas de como desbloquear o nosso site, mantendo o antivírus ativo.</li>
                <li>Sua conexão de internet está bloqueando: tente utilizar uma rede diferente, como Wi-Fi ou 3G/4G. Se estiver usando Wi-Fi, tente usar 3G/4G e vice-versa.</li>
                <li>Se nenhuma das soluções anteriores funcionar, considere adquirir uma assinatura paga.</li>
              </ul>
            </p>
            <p>Caso necessite de auxílio ou possua alguma dúvida, estamos disponíveis para ajudar. Nos chame no Whatsapp.</p> */}

          </ModalBody>
        </Modal>

      </CardBody>
    </Card>
  )
}
export default injectIntl(EditorsSummaryChatGPT)
